import ShivaSreeKids2025 from "../Assets/ShivaShriraamKids.jpeg";
import Shreeram22June26Fremont1 from "../Assets/Shreeram-22June26-Fremont-1.jpeg";
import Shreeram22June26Fremont2 from "../Assets/Shreeram-22June26-Fremont-2.jpeg";

const FremontPhotos = [
  {
    img: Shreeram22June26Fremont1,
    alt: "Fremont, CA - Shreeram coaching session - June 22, 2026 - 1",
  },
  {
    img: Shreeram22June26Fremont2,
    alt: "Fremont, CA - Shreeram coaching session - June 22, 2026 - 2",
  },
  {
    img: ShivaSreeKids2025,
    alt: "Shiva Sree Kids 2025",
  },
];

export default FremontPhotos;